module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"successMessage":"The new deal was successfully created."},"fr":{"successMessage":"Le nouveau dossier a été créé avec succès."}}')
  delete Component.options._Ctor
}
